import { createSelector } from '@ngrx/store';

import { type CanvasElement } from '@blaze-runtime/engine-domain';
import { isNullish } from '@blaze-shared/shared-util';

import { entityAdapter, getEngineState } from './engine-adapters';

/*** Adapter Selectors ***/
const { selectAll, selectEntities, selectIds } = entityAdapter.getSelectors();
export const engineAdapterSelectors = {
  selectEntities,
  selectEntitiesIds: selectIds,
  selectEntitiesList: selectAll,
};

/*** Non-exportable selectors  ****/
const selectConnections = createSelector(getEngineState, (state) => state.connections);

// Added to avoid circular dependency errors. Same as @see element.selectors -> getElements
export const selectElements = createSelector(
  getEngineState,
  engineAdapterSelectors.selectEntitiesList,
);

export const selectElementEntities = createSelector(getEngineState, selectEntities);

/*** Exportable selectors ***/

export const selectConnectionsAndEntities = createSelector(
  selectConnections,
  selectElementEntities,
  (connections, entities) => {
    return { connections, entities };
  },
);

/**
 * Find all elements of type 'accountsDropdown'
 */
export const selectAccountsDropdownEntities = createSelector(selectElementEntities, (entities) => {
  const accountsDropdownEntities: CanvasElement[] = [];
  for (const elementId in entities) {
    const entity = entities[elementId];
    if (!isNullish(entity) && entity.type === 'accountsDropdown') {
      accountsDropdownEntities.push(entity);
    }
  }
  return accountsDropdownEntities;
});
